import { useQuery } from '@tanstack/react-query';
import { fetchWards } from '../../../api/administration/demographics/locations';

export const useWards = (filters, options = {}) => {
  const query = useQuery({
    queryKey: ['wards', filters],
    queryFn: () => {
      const params = { ...filters };
      if (params?.pageSize && !params.limit) {
        params.limit = params.pageSize;
      }
      return fetchWards(params);
    },
    keepPreviousData: true,
    enabled: options.enabled,
  });

  return {
    ...query,
    data: query.data?.data?.wards ?? [],
    pagination: query.data?.data?.pagination ?? {
      currentPage: 1,
      pageSize: filters?.pageSize ?? filters?.limit ?? 10,
      totalItems: 0,
      totalPages: 0,
      hasNextPage: false,
      hasPrevPage: false,
    },
  };
};

export default useWards;
